/**
 * OwnerSettings Repository
 * 오너 설정 데이터 저장소
 */
import { OrganizationInfo, OrganizationUpdateRequest } from '../models/OwnerSettings';

export class OwnerSettingsRepository {
  /**
   * 조직 정보 조회 (organizations 테이블에서)
   */
  async getOrganization(organizationId: string): Promise<OrganizationInfo> {
    const accessToken = localStorage.getItem('accessToken');

    if (!accessToken) {
      throw new Error('인증 토큰이 없습니다. 다시 로그인해주세요.');
    }

    const response = await fetch(`/api/v1/owner/organization/${organizationId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('❌ 조직 정보 조회 실패:', errorText);
      throw new Error('조직 정보 조회에 실패했습니다.');
    }

    return await response.json();
  }

  /**
   * 조직 정보 업데이트
   */
  async updateOrganization(data: OrganizationUpdateRequest): Promise<OrganizationInfo> {
    const accessToken = localStorage.getItem('accessToken');

    if (!accessToken) {
      throw new Error('인증 토큰이 없습니다. 다시 로그인해주세요.');
    }

    const response = await fetch('/api/v1/owner/organization/me', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('❌ 조직 정보 업데이트 실패:', errorText);
      throw new Error('조직 정보 업데이트에 실패했습니다.');
    }

    return await response.json();
  }
}

export const ownerSettingsRepository = new OwnerSettingsRepository();
